import React from "react";
import ReactDOM from "react-dom/client";
import "mapbox-gl/dist/mapbox-gl.css";

import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./utils/i18n";
import App from "./App";

import { AppContextProvider } from "./components/Contexts/AppContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppContextProvider />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
